import React from "react";
import { Brain } from "@phosphor-icons/react";

export default function Logo({ size = "md", showName = true, tagline }) {
  const dims = { sm: { box: "w-10 h-10", icon: 20, text: "text-base" }, md: { box: "w-16 h-16", icon: 32, text: "text-2xl" }, lg: { box: "w-20 h-20", icon: 40, text: "text-3xl" } };
  const d = dims[size] || dims.md;
  return (
    <div className="flex flex-col items-center gap-4 select-none">
      <div className={`${d.box} bg-zinc-950 text-white flex items-center justify-center rounded-xl shadow-sm`}>
        <Brain size={d.icon} weight="duotone" />
      </div>
      {showName && (
        <div className="text-center">
          <h1 className={`font-heading ${d.text} font-medium tracking-tight`}>Cognitive Clone</h1>
          {tagline && <p className="overline mt-2">/// {tagline}</p>}
        </div>
      )}
    </div>
  );
}
